<div class="comp-menu">
	<div class="d-flex justify-content-between">
		<div>
			<button
				class="btn btn-icon"
				(click)="modalProps = { name: 'update-policy-form' }"
				titleLang="add"
				icon="plus"
			></button>
		</div>
	</div>
	<div class="items">
		<div class="d-flex">
			<div class="colstat-big">
				<label>{{ "name" | langVal }}</label>
			</div>
      <div class="colstat-small">
				<label>{{ "version" | langVal }}</label>
			</div>
			<div class="colstat-small">
				<label></label>
			</div>
			<div class="colstat-big-double">
				<label>{{ "person_types" | langVal }}</label>
			</div>
			<div class="colstat-small">
				<label>{{ "sent" | langVal }}</label>
			</div>
			<div class="colstat-small">
				<label>{{ "filled" | langVal }}</label>
			</div>
			<div class="colstat-small">
				<label>{{ "unanswered" | langVal }}</label>
			</div>
			<div class="colstat-small">
				<label>{{ "send_status_sent" | langVal }}</label>
			</div>
			<div class="colstat-small">
				<label>{{ "send_status_read" | langVal }}</label>
			</div>
			<div class="text-end colstat-small"></div>
		</div>
		@for (row of policyForms; track row.id) {
			<div
				class="tests-autotext-menu-list d-flex"
				(click)="openInvite(row)"
			>
				<div class="colstat-big">
					{{ row.name }}
				</div>
        <div class="colstat-small">
          {{ row.latestVersion?.description }}
				</div>
				<div class="colstat-small">
					<app-icon
						icon="settings1"
						(click)="openUpdate(row); $event.stopImmediatePropagation()"
					/>
				</div>
				<div class="colstat-big-double">
					{{ row.person_types }}
				</div>
				<div class="colstat-small">
					{{ row.sent_count }}
				</div>
				<div class="colstat-small">
					{{ row.filled_count }}
				</div>
				<div class="colstat-small">
					{{ row.unanswered_count }}
				</div>
				<div class="colstat-small">
					{{ row.send_status_sent }}
				</div>
				<div class="colstat-small">
					{{ row.send_status_read }}
				</div>
				@if (curOpenId != row.id) {
					<div class="colstat-small">
						<h6>{{ "signing_state" | langVal }}</h6>
					</div>
				}
			</div>
			@if (curOpenId === row.id) {
				<app-policy-form-invite [id]="row.id" />
			}
		}
	</div>
</div>

@switch (modalProps?.name) {
	@case ("update-policy-form") {
		<app-modal-wrap
			(onClose)="modalProps = null; getItems()"
			title="document"
			modalWrapperClass="modal-100-width"
		>
			<app-update-policy-form
				(onClose)="modalProps = null; getItems()"
				[policyForm]="modalProps.policyForm"
			/>
		</app-modal-wrap>
	}
}
